import React, { Component } from 'react'
import styles from './style.module.less'
import { Radio } from 'hljd'
import Store from './store'
import { observer } from 'mobx-react'
import Pay from './Pay'
import { HeaderView } from '@merchant-backend/common-components'
const RadioGroup = Radio.Group

@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store()

    const {
      location: { query }
    } = this.props
    this.store.initParams(query)
  }

  render() {
    const radioStyle = {
      display: 'block',
      padding: '20px 16px',
      borderBottom: '1px solid #e7e7e7'
    }

    const {
      payType,
      price,
      title,
      orderPrice,
      payMoney,
      changePayType
    } = this.store

    return (
      <HeaderView title={<span style={{ fontWeight: 'bold' }}>收银台</span>}>
        <div className={styles.inner}>
          <p className={styles.p1}>订单类型：{title}</p>
          <p className={styles.p2}>
            产品价格：<span>{orderPrice}</span>元
          </p>

          <RadioGroup onChange={changePayType} value={payType}>
            <Radio style={radioStyle} value={2} disabled={Number(price) <= 0}>
              <img src="http://qnm.hunliji.com/o_1boucjbkf48tqtg1gv2sfshoqb.png" />
              <span className={styles.name}>支付宝支付</span>
              {payType == 2 && (
                <span className={styles.desc}>
                  支付<span>{price}</span>元
                </span>
              )}
            </Radio>
            <Radio style={radioStyle} value={1} disabled={Number(price) <= 0}>
              <img src="http://qnm.hunliji.com/o_1boucjbkf9hi16naqvnmpv1c2kc.png" />
              <span className={styles.name}>微信支付</span>
              {payType == 1 && (
                <span className={styles.desc}>
                  支付<span>{price}</span>元
                </span>
              )}
            </Radio>
          </RadioGroup>
        </div>
        <div className={styles.paybtn}>
          <div onClick={payMoney}>确认支付</div>
        </div>

        <Pay store={this.store} />
      </HeaderView>
    )
  }
}
